<ng-container *ngIf="addressList$ | async as addressList">
  <ng-container *ngIf="accountTranslations$ | async as accountTranslations">
    <ng-container
      *ngIf="addressListTranslations$ | async as addressListTranslations"
      ><ng-container
        *ngIf="validationTranslations$ | async as validationTranslations"
      >
        <div id="ch-ggs-web-suite-content">
          <div class="container">
            <div class="row">
              <div class="col-md-10">
                <ng-container *ngIf="!isEditMode; else edit">
                  <div>
                    <button
                      type="button"
                      class="btn btn-iconed btn-iconed-primary"
                      (click)="addAddress()"
                    >
                      {{ addressListTranslations['ButtonAddAddress'] }}
                      <i
                        class="btn-icon ifc-custom ifc-add"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                  <table class="table table-striped table-hover mt-3">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col" class="float-right">
                          {{ accountTranslations['Actions'] }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let address of addressList; trackBy: identify"
                      >
                        <td [innerHtml]="address.FullAddress | safeHtml"></td>
                        <td class="float-right">
                          <button
                            type="button"
                            class="btn btn-iconed btn-iconed-primary"
                            (click)="selectAddress(address)"
                          >
                            <i
                              class="ifc-custom ifc-arrow-right d-flex align-items-center justify-content-center"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-iconed btn-iconed-primary ml-2"
                            (click)="editAddress(address)"
                          >
                            <i
                              class="ifc-custom ifc-pencil d-flex align-items-center justify-content-center"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <ng-container
                    *ngIf="
                      validationTranslations$ | async as validationTranslations
                    "
                  ></ng-container>
                  <p *ngIf="!addressList">
                    {{ validationTranslations['NoItemsInList'] }}
                  </p>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <ng-template #edit>
          <hazmatsuite-next-address-editor
            [item]="editItem"
            [countries]="(countryList$ | async) || []"
            (editCallback)="editCallback()"
          ></hazmatsuite-next-address-editor>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
